import React from 'react';
import { Link } from 'react-router-dom';
import { BsArrowRight } from "react-icons/bs";
import Img1 from '../images/Carson Road Project/For Website/POST CONSTRUCTION_.jpg';
import Img2 from '../images/Concept Drawings & Renderings/242 Park - Concept Drawing 2(1).jpg';
import Img3 from '../images/project3.jpg';
import Img4 from '../images/project4.jpg';
import Img5 from '../images/project5.jpg';
import Img6 from '../images/project6.jpg';

export default () => (
	<div className='projects-page'>
		<h4>Our Projects</h4>
		<p>
			New Wave Property Group transforms vacant infill lots into multi-unit rental buildings that respond to Canada’s evolving housing needs. From empty or underutilized land to thoughtfully planned low-rise to mid-rise projects, each development is designed to balance everyday comfort, long-term durability, and strong financial performance. Explore a sample of our past, current, and upcoming projects below.
		</p>
		<Link to='/contactpage'>
			<button className="projectpage-button">GET IN TOUCH</button>
		</Link>
		<div class="projectpage-split">

			<a class="editorial-item" href="/projects/CarsonRoad">
				<div class="editorial-container">
					<img class="projectspage-img" src={Img1}></img>
					<div class="project-overlay">
						<div class="project-text">The Carson Road Project</div>
					</div>
				</div>
			</a>

			<a class="editorial-item" href="/projects/project2">
				<div class="editorial-container">
					<img class="projectspage-img" src={Img2}></img>
					<div class="project-overlay">
						<div class="project-text">The Carillon Project</div>
					</div>
				</div>
			</a>

			<a class="editorial-item" href="/projects/project3">
				<div class="editorial-container">
					<img class="projectspage-img" src={Img3}></img>
					<div class="project-overlay">
						<div class="project-text">Upcoming Projects</div>
					</div>
				</div>
			</a>
		</div>
	</div>
);
